import {getDataForTabs, getDataForTabsRent, getDataPricesForTabs} from './AllTabsSummary'
import {Component, React, observer, resolveCss} from '$src/handy'
import * as css from './TabSummary.css'
import {ResearchStateTab, HousingCorporation} from '$src/bootstrap/Store'

interface Props {
  css?: any
  activeTabState: typeof ResearchStateTab.Type
  housingCorporation: typeof HousingCorporation.Type
  toggleRentData: () => void
  rentTabState: boolean
}

interface State {}

const classes = resolveCss(css, {})

@observer
export default class TabSummary extends Component<Props, State> {
  constructor(props: Props, context: any) {
    super(props, context)
    this.state = {}
  }

  render() {
    const {props} = this
    const data = getDataForTabs(
      [props.activeTabState],
      props.housingCorporation,
    )

    const rentData = getDataForTabsRent(
      [props.activeTabState],
      props.housingCorporation,
    )

    const dataPrices = getDataPricesForTabs(
      [props.activeTabState],
      props.housingCorporation,
    )

    return (
      <div {...classes('root')}>
        <div {...classes('leftTable')}>
          {/* PRICE TABLE */}
          {!props.rentTabState && (<>
            <h4>Price information</h4>
            <table {...classes('table')}>
              <thead>
                <tr>
                  {columns.map(col => {
                    return <th key={col.accessor}>{col.Header}</th>
                  })}
                </tr>
              </thead>
              <tbody>
                {data.map((row, i) => {
                  return <Row key={'row-' + i} row={row} columns={columns} />
                })}
              </tbody>
            </table>
            </>
          )}
          
          {/* RENT TABLE */}
          {props.rentTabState && (
            <>
            <h4>Rent information</h4>
            <table {...classes('table')}>
              <thead>
                <tr>
                  {columns.map(col => {
                    return <th key={col.accessor}>{col.Header}</th>
                  })}
                </tr>
              </thead>
              <tbody>
                {rentData.map((row, i) => {
                  return <Row key={'row-' + i} row={row} columns={columns} />
                })}
              </tbody>
            </table>
            </>
          )}
          
        </div>
        {!props.rentTabState && (
          <div {...classes('rightTable')}>
            {/* INDEXED PRICES TABLE */}
            <h4>Development of indexed median price/sqm</h4>

            <table {...classes('table')}>
              <thead>
                <tr>
                  {columnsPrices.map(col => {
                    return <th key={col.accessor}>{col.Header}</th>
                  })}
                </tr>
              </thead>
              <tbody>
                {dataPrices.map((row, i) => {
                  return (
                    <Row key={'row-' + i} row={row} columns={columnsPrices} />
                  )
                })}
              </tbody>
            </table>
          </div>
        )}        
      </div>
    )
  }
}

const Row = (props: {
  row: {[s: string]: string}
  columns: Array<{accessor: string; Header: string}>
}) => {
  return (
    <tr>
      {props.columns.map(col => {
        return <td key={'col-' + col.accessor}>{props.row[col.accessor]}</td>
      })}
    </tr>
  )
}

const columns = [
  {accessor: 'numberOfRooms', Header: 'Number of rooms'},
  {accessor: 'firstQuartile', Header: 'First quartile'},
  {accessor: 'median', Header: 'Median'},
  {accessor: 'thirdQuartile', Header: 'Third quartile'},
  {accessor: 'averagePrice', Header: 'Average'},
  {accessor: 'averageArea', Header: 'Average area'},
  {accessor: 'total', Header: 'Total items'},
]

export const columnsPrices = [
  {accessor: 'current', Header: 'Current'},
  {accessor: 'firstQuartileAgo', Header: '1Q ago'},
  {accessor: 'secondQuartileAgo', Header: '2Q ago'},
  {accessor: 'thirdQuartileAgo', Header: '3Q ago'},
  {accessor: 'fourthQuartileAgo', Header: '4Q ago'},
]




// WEBPACK FOOTER //
// ./src/comparableSales/TabSummary.tsx